import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { CellContext } from '@tanstack/react-table';

import i18n from '@app/core/locale/i18n';

export interface ChannelListUpdatedAtCellProps
  extends CellContext<
    GatewayChannelWithChargePointInfoModel,
    GatewayChannelWithChargePointInfoModel['updatedAt']
  > {}

export const ChannelListUpdatedAtCell = (
  props: ChannelListUpdatedAtCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{formatDate(getValue(), i18n)}</Text>;
};
